import Dosage, {DosageCreateRequest, DosageInput} from "@/dosage/interfaces/Dosage";
import {DosageFormData} from "@/dosage/interfaces/DosageForm";

const DosageFormService = () => {
    return {
        /**
         * Default form value for dosage form.
         */
        defaultFormValue : (): DosageFormData => ({
            times: [
                {dose: 0, time: '08:00'},
                {dose: 0, time: '12:00'},
                {dose: 0, time: '19:00'},
                {dose: 0, time: '22:00'},
            ],
            dose: null,
            instruction: null,
            frequency: null,
            start: new Date(),
            end: null,
            dates: null,
        }),

        /**
         * Map an existing dosage to the form data structure.
         */
        mapExistingDosageToForm(dosage: Dosage): DosageFormData {
            return {
                times: dosage.times,
                dose: dosage.dose ?? null,
                instruction: dosage.instruction?.id ? dosage.instruction : null,
                frequency: dosage.frequency?.id ? dosage.frequency : null,
                start: dosage.start_at ? new Date(dosage.start_at) : null,
                end: dosage.end_at ? new Date(dosage.end_at) : null,
                dates: dosage.dates ? dosage.dates.map(d => ({id: d.id, value: new Date(d.value)})) : null,
            };
        },

        /**
         * Map the dosage form data to the payload for creation or update.
         */
        mapDosageFormDataToPayload(productId: number, consumerKey: string, data: DosageFormData): DosageCreateRequest {
            return {
                consumer_key: consumerKey,
                ...this.mapDosageFormDataToInput(productId, data),
            };
        },

        /**
         * Map the dosage form data to the dosage input, without the consumer.
         */
        mapDosageFormDataToInput(productId: number, data: DosageFormData): DosageInput {
            return {
                product_id: productId,
                dosage_dose_id: data.dose?.id ?? null,
                dosage_frequency_id: data.frequency?.id ?? null,
                dosage_instruction_id: data.instruction?.id ?? null,
                start_at: !data.dates?.length ? data.start?.toISOString() : null,
                end_at: !data.dates?.length ? data.end?.toISOString() : null,
                dates: data.dates?.length ? data.dates.map(date => ({
                    id: date.id,
                    value: date.value.toISOString()
                })) : null,
                times: data.times
                    .filter(time => time.dose)
                    .map(time => ({
                        id: 'id' in time ? time.id : undefined,
                        dose: time.dose,
                        time: 'time' in time ? time.time : undefined,
                        dosage_time_trigger_id: 'dosage_time_trigger_id' in time ? time.dosage_time_trigger_id : undefined,
                    })),
            };
        }
    };
};

export default DosageFormService();
